module.exports = __webpack_public_path__ + "static/img/insurance-product-8.b9aa526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-product-8.png
// module id = Ef0M
// module chunks = 4